import * as React from "react";
import {
  DataGridPro,
  GridActionsCellItem,
  GridToolbarFilterButton,
  GridColDef,
  GridToolbarContainer,
  GridToolbarExport,
  GridRowClassNameParams,
} from "@mui/x-data-grid-pro";

export const DataGrid = (props: any) => {
  const CustomToolbar = () => {
    return (
      <GridToolbarContainer>
        <GridToolbarExport />
        <GridToolbarFilterButton />
      </GridToolbarContainer>
    );
  }
  return (
    <DataGridPro
      sx={{
        backgroundColor: "white",
        "& .MuiDataGrid-columnHeader": {
          backgroundColor: "#253746",
          color: "white",
        },
        "& .MuiDataGrid-sortIcon": {
          color: "white",
        },
        "& .MuiDataGrid-filterIcon": {
          color: "white",
        },
        '& .MuiDataGrid-cell' :{
                  whiteSpace:'normal',
                  wordWrap:'break-word',
                  lineHeight:'1.5rem',
                  alignItems:'center',
                  display:'flex',
                  justifyContent:'file-start',
                  marginBottom:'5px',
                  textAlign:'left',
                },
        height: 600,
      }}
      getRowId={props.getRowId}
      rows={props.rows}
      columns={props.columns}
      pagination
      rowCount={props.rowCount}
      paginationModel={props.paginationModel}
      onPaginationModelChange={props.PaginationModelChange}
      filterModel={props.filterModel}
      onFilterModelChange={props.filterModelChange}
      pageSizeOptions={[10, 25, 50]}
      getRowHeight={() => 'auto'}
      // rowHeight={40}
      paginationMode="server"
      filterMode="server"
      loading={props.loading}
      slots={{
        toolbar: props.customToolbar,
        //noRowsOverlay: CustomDataGridNoRowOverlay,
      }}
      checkboxSelection={props.checkboxSelection} 
      onRowSelectionModelChange = {props.onRowSelectionModelChange}
      rowSelectionModel = {props.rowSelectionModel}
      showCellVerticalBorder={true}
      showColumnVerticalBorder={true}
      getRowClassName={(params: GridRowClassNameParams) => params.indexRelativeToCurrentPage % 2 === 0 ? 'even-row' : 'odd-row'}
    />
  )
}

